import { Map, fromJS } from 'immutable';
import Actions from 'flow/actions';

const initialVideo2State = Map({
    extensionKey: null,
    meetingCode: null,
    direction: null,
    status: null,
});

export const video2Reducer = (state = initialVideo2State, action: any) => {
    switch (action.type) {
        case Actions.CLEAR_STATE: {
            return initialVideo2State;
        }
        case Actions.VIDEO2_INCOMING_CALL: {
            return state.mergeDeep(fromJS(action.payload));
        }
        case Actions.VIDEO2_OUTGOING_CALL: {
            return state.mergeDeep(fromJS(action.payload));
        }
        case Actions.VIDEO2_CLEAR_CALL_STATE: {
            return initialVideo2State;
        }
        case Actions.VIDEO2_CALL_DECLINED: {
            return state.set('status', 'declined');
        }
        case Actions.VIDEO2_CALL_ACCEPTED: {
            return state.set('status', 'accepted');
        }
        case Actions.VIDEO2_CALL_CANCELED: {
            return state.set('status', 'canceled');
        }
        case Actions.VIDEO2_CALL_HANDLED: {
            return state.set('status', 'handledOnOtherDevice');
        }
        default: {
            return state;
        }
    }
};

export default video2Reducer;
